import { useEffect } from "react";

export const useOutsideClick = (refs, handler) => {
  useEffect(() => {
    const listener = (event) => {
      const isInside = refs.some(
        (ref) => ref.current && ref.current.contains(event.target)
      );

      if (!isInside) handler();
    };

    document.addEventListener("mousedown", listener);
    return () => document.removeEventListener("mousedown", listener);
  }, [refs, handler]);
};